import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { Paper } from '@mui/material';
import { getRoute } from '../../../routes';
import SiemEventLog from './SiemEventLog';
import './SiemAdministration.css';

/**
 * Sub page of the SIEM administration with the event log; it is not listed in the navigation.
 */
export default function SiemEventsPage ({ navBar: propNavBar }) {
  const navigate = useNavigate();

  React.useEffect(() => {
    const navBar = propNavBar?.current || propNavBar;
    if (!navBar) return;
    navBar.setTitle(<FormattedMessage id='siem.events.title'/>);
    navBar.showBackButton(true, () => navigate(getRoute('siem').to));
    // NavigationBar does not update the title when returning to a parent path, so the SIEM page title is restored here.
    return () => {
      navBar.showBackButton(false);
      navBar.setTitle(<FormattedMessage id='siem.title'/>);
    };
  }, [propNavBar, navigate]);

  return (
    <div className='siem root'>
      <div className='main'>
        <Paper className='siemEvents'>
          <SiemEventLog/>
        </Paper>
      </div>
    </div>
  );
}

SiemEventsPage.propTypes = {
  navBar: PropTypes.object
};
